import React, { useEffect } from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useModalState } from "src/hooks/useModalState";
import { isShowModalState } from "src/libs/browser";
import { LINK_REMIND, LINK_REMIND_MONTHLY_EXAM, LINK_REMIND_TUTOR, URL_TEMPLATE } from "src/libs/constant";
import Link from "next/link";

export function ModalRemindMonthlyExam() {
  const { t } = useTranslation();
  const { isModalVisible, handleClose, handleOpen } = useModalState();
  useEffect(() => {
    if (isShowModalState()) {
      handleOpen()
      document.cookie = `showModal=0; path=/`;
    }
    return () => {
      handleCloseModal()
    }
  }, [])

  const handleCloseModal = () => {
    document.cookie = `showModal=0; path=/`;
    handleClose();
  };
  return (
    <Modal 
      visible={isModalVisible} 
      destroyOnClose
      width={580}
      footer={null}
      className="banner-when-login__container"
    >
      <div className="banner-when-login__wrap" style={{ width: '600px' }}>
        <div className="banner-when-login__btn-close">
          <Button 
            style={{
              padding: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '50%',
              backgroundColor: '#4A32B4',
              color: '#8E74FD',
              fontWeight: '900',
              border: 'none',
              height: '33px',
              width: '35px',
            }}
            onClick={handleCloseModal}
          >X</Button>
        </div>
        <div>
          {/* <img src="/image/background-cloud.png" alt="cloud" className="background-cloud"/> */}
          <div className="banner-when-login__remind-monthly-exam">
            <div className="banner-when-login__remind-wrap">
              <span className="banner-when-login__remind-student">Học sinh sẽ</span>&nbsp;&nbsp;
              <span className="banner-when-login__remind-no-progress">Không tiến bộ</span>
            </div>
            <div className="banner-when-login__remind-content">
              <span className="banner-when-login__remind-content-warning">nếu không tham gia</span>&nbsp;
              <span className="banner-when-login__remind-content-homework">THI THÁNG</span>
            </div>
          </div>
        </div>
        <img src="/image/avatar-student.png" alt="avatar-student" className="avatar-student_monthly-exam"/>
        <div className="banner-when-login__content-description">
          <div className="banner-when-login__description">
            <p className="px-2">Học sinh không tham gia THI THÁNG nếu bạn không thực hiện hướng dẫn và kiểm tra</p>
            <div className="description" style={{ padding: '0 10px' }}>Hãy kiểm tra và nhắc nhở học sinh tham gia THI THÁNG trong buổi học Regular (Buổi 1) và Basic (BA) theo đúng kịch bản nhé!</div>
            <img src="/image/light-bulb.png" alt="light-bulb" className="light-bulb"/>
          </div>
          <div className="banner-when-login__button">
            <Link href={LINK_REMIND_MONTHLY_EXAM}>
              <a target="_blank" className="navigate__btn-remind">
                <button onClick={handleCloseModal} className="btn-remind">
                    Kịch bản thi tháng
                </button>
              </a>
            </Link>
            <Link href={`${URL_TEMPLATE.SESSION_TEACHING_SCHEDULE}`}>
              <Button onClick={handleCloseModal} Button className="btn-check">Kiểm tra ngay</Button>
            </Link>
          </div>
        </div>
      </div>
    </Modal>
  );
}
